import { Box, Typography, IconButton } from "@mui/material";
import {
  AutoAwesome as AutoAwesomeIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

const ChatHeader = ({ isSmallScreen, title, subtitle, onClose }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        position: "relative",
        px: { xs: 2, sm: 3 },
        pt: { xs: 2, sm: 3 },
        pb: { xs: 2, sm: 2 },
        pr: isSmallScreen ? 5 : { xs: 2, sm: 3 },
        flexShrink: 0,
        borderBottom: "1px solid #E0E0E0",
      }}
    >
      <Box
        sx={{
          p: 1.5,
          bgcolor: "primary.main",
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AutoAwesomeIcon sx={{ color: "#ffffff !important", fontSize: 20 }} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            color: "text.primary",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {isSmallScreen ? (
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            top: "50%",
            right: { xs: 8, sm: 12 },
            transform: "translateY(-50%)",
            zIndex: 3,
            "&:hover": {
              bgcolor: "transparent",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </Box>
  );
};

export default ChatHeader;
